import { Button, Typography, InputAdornment, IconButton, Box } from '@mui/material';
import { FormTextField } from '@/components/HookForm';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet-async';
import { Lock as LockIcon, Visibility as ShowIcon, VisibilityOff as HideIcon } from '@mui/icons-material';

import { signInSession, getToken, setTemporaryToken } from '@/services/auth.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { dialogOpen } from '@/modules/MuiDialog';
import { checkOpenState } from '@/services/open-mall.service';
import { useTranslation } from 'react-i18next';
import ResetPasswordDialog from './SodomallPartnerLogin/ResetPasswordDialog';

import sodomallPartnerLoginBg from '@/assets/images/page/sodomall_partner_login.jpg';

export default (props: any) => {
    const { t } = useTranslation();
    const form = useForm();
    const {
        handleSubmit,
        getValues,
        formState: { isValid, isSubmitting },
        reset,
    } = form;
    const navigate = useNavigate();

    const [queries] = useSearchParams();
    let refer = queries.get('refer');
    const [isPassView, setIsPassView] = useState(false);
    const [isResetPasswordDialogOpen, setIsResetPasswordDialogOpen] = useState(false);

    useEffect(() => {
        let sellerEmail = queries.get('email') || '';
        if (!!sellerEmail) {
            reset({
                email: sellerEmail,
            });
        }
    }, []);

    const signIn = async (data: any) => {
        try {
            if (!isValid || isSubmitting) return;
            const email = data.email.trim();
            const password = data.password;
            const session = await signInSession(email, password);

            toast.success(t('auth.loginSuccess'));

            if (!refer) {
                navigate(`/studio/${session.userId}`);
            } else {
                navigate(refer);
            }
        } catch (e: any) {
            console.error(e);

            if (!!e.data?.placeHolder || !!e.placeHolder) {
                toast.error(e.data?.placeHolder || e.placeHolder);
            } else {
                if (e.status === 302) {
                    toast.error(t('auth.accountDeactivated'));
                    return;
                }

                if (e.code === 'not-exist-own-mall') {
                    const { userId, userSecret } = e.data?.signInInfo || {};

                    console.log('%c test-excepted-login', 'color:red;background-color:yellow;', { userId, userSecret });
                    const { accessToken } = await getToken(userId, userSecret);

                    if (!accessToken) return;
                    const state = await checkOpenState(accessToken);

                    if (!state) {
                        dialogOpen({
                            title: '아직 상점을 개설하지 않으셨네요!',
                            message: '본인만의 상점을 개설하시겠어요?',
                            confirmText: '지금 신청하러 가기',
                            onConfirmed: async () => {
                                try {
                                    setTemporaryToken(accessToken);

                                    console.log('data', e.data);
                                    navigate('/register', {
                                        state: e.data?.signInInfo,
                                    });
                                } catch (e: any) {
                                    if (e.data?.placeHolder || e.placeHolder) {
                                        toast.error(e.data?.placeHolder || e.placeHolder);
                                    } else {
                                        console.error(e);
                                    }
                                }
                            },
                            onClose: () => {
                                console.log('%c onClose-action', 'background-color:rgba(255,255,0,0.5);color:red;');
                            },
                            closeText: '나중에 할게요',
                            closeButtonProps: {
                                color: 'error',
                            },
                        });
                    } else {
                        setTemporaryToken(accessToken);
                        navigate('/register');
                    }

                    return;
                }

                toast.error(t('auth.loginFailed'));
                console.error(e);
            }
        }
    };

    return (
        <>
            <Helmet titleTemplate={`%s 소도몰 파트너 로그인`}>
                <style>{`
                    .sodomall-login-form-container,
                    .sodomall-login-form-container *,
                    .sodomall-login-form-container form,
                    .sodomall-login-form-container .MuiBox-root {
                        background-color: transparent !important;
                        background: transparent !important;
                    }
                    .sodomall-login-form-container .MuiOutlinedInput-root {
                        background-color: white !important;
                    }
                `}</style>
            </Helmet>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    overflow: 'hidden',
                }}
            >
                {/* 배경 이미지 */}
                <Box
                    component="img"
                    src={sodomallPartnerLoginBg}
                    alt="Sodomall Partner Login Background"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 0,
                    }}
                />

                {/* 로그인 폼 컨테이너 */}
                <Box
                    className="sodomall-login-form-container"
                    sx={{
                        position: 'relative',
                        zIndex: 2,
                        width: '100%',
                        maxWidth: 360,
                        px: 4,
                        pt: 6,
                    }}
                >
                    {/* 로고 영역 */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            mb: 3,
                        }}
                    >
                        <Box
                            component="img"
                            src="/sodomall_logo.png"
                            alt="Sodomall Logo"
                            sx={{
                                maxWidth: '200px',
                                width: 'auto',
                                height: 'auto',
                            }}
                        />
                    </Box>

                    {/* 로그인 폼 */}
                    <Box
                        sx={{
                            backgroundColor: 'transparent',
                        }}
                    >
                        <form onSubmit={handleSubmit(signIn)} style={{ backgroundColor: 'transparent' }}>
                            {/* 이메일 입력 */}
                            <Box sx={{ mb: 0, backgroundColor: 'transparent' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 0.5,
                                        color: 'text.primary',
                                        fontWeight: 500,
                                        fontSize: '0.875rem',
                                    }}
                                >
                                    이메일(계정)
                                </Typography>
                                <FormTextField
                                    placeholder="이메일을 입력해주세요"
                                    name={'email'}
                                    form={form}
                                    rules={[(v) => !!v || t('auth.emailRequired')]}
                                    fullWidth
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white',
                                            minHeight: '48px',
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#363ac3',
                                            },
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#363ac3',
                                            },
                                        },
                                    }}
                                />
                            </Box>

                            {/* 비밀번호 입력 */}
                            <Box sx={{ mb: 0, backgroundColor: 'transparent' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 0.5,
                                        color: 'text.primary',
                                        fontWeight: 500,
                                        fontSize: '0.875rem',
                                    }}
                                >
                                    비밀번호
                                </Typography>
                                <Box sx={{ backgroundColor: 'transparent' }}>
                                    <FormTextField
                                        placeholder="비밀번호를 입력해주세요"
                                        name={'password'}
                                        form={form}
                                        rules={[(v) => !!v || t('auth.passwordRequired')]}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position={'end'}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setIsPassView(!isPassView);
                                                        }}
                                                        edge="end"
                                                    >
                                                        {isPassView ? <HideIcon /> : <ShowIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        type={isPassView ? 'text' : 'password'}
                                        fullWidth
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white',
                                                minHeight: '48px',
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#363ac3',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#363ac3',
                                                },
                                            },
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            mt: 0,
                                            backgroundColor: 'transparent',
                                        }}
                                    >
                                        <Button
                                            size="small"
                                            startIcon={<LockIcon sx={{ fontSize: 14 }} />}
                                            onClick={() => {
                                                setIsResetPasswordDialogOpen(true);
                                            }}
                                            sx={{
                                                textTransform: 'none',
                                                color: 'text.secondary',
                                                fontSize: '0.7rem',
                                                minWidth: 'auto',
                                                p: 0.5,
                                                backgroundColor: 'transparent',
                                            }}
                                        >
                                            비밀번호 찾기
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>

                            {/* 로그인 버튼 */}
                            <Button
                                variant="outlined"
                                size="large"
                                type={'submit'}
                                disabled={isSubmitting}
                                fullWidth
                                sx={{
                                    mt: 3,
                                    py: 1.5,
                                    backgroundColor: 'white',
                                    borderColor: '#ffffff',
                                    borderWidth: '4px',
                                    borderStyle: 'solid',
                                    color: '#ffffff',
                                    fontSize: '0.9rem',
                                    fontWeight: 900,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    borderRadius: 1,
                                    '&:hover': {
                                        backgroundColor: '#F5F5F5',
                                        borderColor: '#BDBDBD',
                                        borderWidth: '4px',
                                        color: '#616161',
                                    },
                                    '&:disabled': {
                                        backgroundColor: '#F5F5F5',
                                        borderColor: '#E0E0E0',
                                        borderWidth: '4px',
                                        color: '#BDBDBD',
                                    },
                                }}
                            >
                                LOGIN
                            </Button>
                        </form>
                    </Box>
                </Box>
            </Box>
            <ResetPasswordDialog
                open={isResetPasswordDialogOpen}
                onClose={() => setIsResetPasswordDialogOpen(false)}
                email={getValues('email')}
            />
        </>
    );
};
